module.exports = __webpack_public_path__ + "img/Pro-09.c81fddd8.jpg";